import { TableTd } from '@/components/ui/data-display/tables/TableTd';

export const TableCell = ({ data }) => {
  return (
    <TableTd
      data={{
        title: data?.fields?.title,
        colspan: data?.fields?.colspan,
        rowspan: data?.fields?.rowspan,
      }}
    />
  );
};
